import { DocumentType, NotificationType } from '@/classes/generated-models'

export function getDocumentIcon(type: NotificationType | DocumentType): string {
  switch (type) {
    case DocumentType.Certificates:
      return 'icons8-certificate'
    case NotificationType.Invoices:
    case DocumentType.Invoices:
      return 'icons8-invoice'
    case NotificationType.PackingSlips:
    case DocumentType.PackingSlips:
      return 'icons8-purchase-order'
    case NotificationType.SalesAgreements:
    case DocumentType.SalesAgreements:
      return 'icons8-petition'
    case NotificationType.SalesOrders:
    case DocumentType.SalesOrders:
      return 'icons8-document'
    default: return ''
  }
}
